import { PayloadAction } from '@reduxjs/toolkit';

import { ProductPersonalizerState } from 'product-personalizer/src/store/productPersonalizer/slice';

const setDesignIsLoadingReducer = (state: ProductPersonalizerState, action: PayloadAction<boolean>) => {
  state.designIsLoading = action.payload;
};

export default setDesignIsLoadingReducer;
